import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commentsPipe'
})
export class CommentsPipePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!value) { return 'no comments'; }

    return value;
  }

}



// WEBPACK FOOTER //
// /Users/bdegroot/Projects/vgtropics-ph/src/app/comments-pipe.pipe.ts